import {
    DIC
} from '@/const/dic'
import {
    validateChinese
} from '@/util/validate'
export const teamMessageOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    viewBtn: false,
    menuWidth: '300',
    defaultSort:{
        prop: 'createTime',
        order: 'descending'
    },
    column: [
        {
            label: "团队消息标题",
            prop: "subject",
            type: "input"
        },
        {
            label: "团队消息内容",
            prop: "content",
            type: "textarea",
            span: 24,
            max: 255
        },
        {
            label: "选择发送团队",
            prop: "team",
            hide: true,
            formsolt: true
        },
        {
            label: "发送团队",
            prop: "teams",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "状态",
            prop: "status",
            type: "input",
            solt: true,
            addVisdiplay: false,
            editVisdiplay: false
        }
    ]
};